module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('component-header', _vm._b({}, 'component-header', {
    title: _vm.title,
    description: _vm.description
  }, false)), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('Grid', [_c('Grid-item', [_c('div', {
    staticClass: "demo"
  }, [_vm._v("lorem")])]), _vm._v(" "), _c('Grid-item', [_c('div', {
    staticClass: "demo"
  }, [_vm._v("ipsum")])]), _vm._v(" "), _c('Grid-item', [_c('div', {
    staticClass: "demo"
  }, [_vm._v("dolor sit amet")])])], 1), _vm._v(" "), _c('h2', [_vm._v("Width")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.width_values), function(fraction, i) {
    return _c('Grid', {
      key: i
    }, _vm._l((fraction), function(elem, j) {
      return _c('Grid-item', {
        key: j,
        attrs: {
          "width": ("1/" + fraction)
        }
      }, [_c('div', {
        staticClass: "demo"
      }, [_vm._v("1/" + _vm._s(fraction))])])
    }))
  }), _vm._v(" "), _c('h2', [_vm._v("Nested grids")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("We can obviously nest grids to create complex layouts.")]), _vm._v(" "), _c('Grid', [_c('Grid-item', {
    attrs: {
      "width": "1/2"
    }
  }, [_c('div', {
    staticClass: "demo"
  }, [_vm._v("1/2")])]), _vm._v(" "), _c('Grid-item', {
    attrs: {
      "width": "1/2"
    }
  }, [_c('Grid', _vm._l(([1, 2, 3, 4]), function(i) {
    return _c('Grid-item', {
      key: i,
      attrs: {
        "width": "1/4"
      }
    }, [_c('div', {
      staticClass: "demo"
    }, [_vm._v("1/4")])])
  }))], 1)], 1), _vm._v(" "), _c('h2', [_vm._v("Size modifier")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("This modifier provides different gutter sizes.")]), _vm._v(" "), _vm._l((_vm.size_values), function(size) {
    return _c('div', {
      key: size
    }, [_c('h3', [_vm._v(_vm._s(size))]), _vm._v(" "), _c('Grid', _vm._b({}, 'Grid', {
      size: size
    }, false), _vm._l(([1, 2, 3]), function(i) {
      return _c('Grid-item', {
        key: i,
        attrs: {
          "width": "1/3"
        }
      }, [_c('div', {
        staticClass: "demo"
      }, [_vm._v("1/3")])])
    }))], 1)
  }), _vm._v(" "), _c('h2', [_vm._v("Align modifier")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("This modifier change the items alignment without modifying its height.")]), _vm._v(" "), _vm._l((_vm.valign_values), function(valign) {
    return _c('div', {
      key: valign
    }, [_c('h3', [_vm._v(_vm._s(valign))]), _vm._v(" "), _c('Grid', _vm._b({}, 'Grid', {
      valign: valign
    }, false), [_c('Grid-item', {
      attrs: {
        "width": "1/3"
      }
    }, [_c('div', {
      staticClass: "demo"
    }, [_vm._v("1/3")])]), _vm._v(" "), _c('Grid-item', {
      attrs: {
        "width": "1/3"
      }
    }, [_c('div', {
      staticClass: "demo"
    }, [_vm._v(_vm._s(_vm.slot))])]), _vm._v(" "), _c('Grid-item', {
      attrs: {
        "width": "1/3"
      }
    }, [_c('div', {
      staticClass: "demo"
    }, [_vm._v("1/3")])])], 1)], 1)
  }), _vm._v(" "), _c('h2', [_vm._v("Liquid modifier")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("Liquid modifier makes every grid item to naturally space themsevles equally and expand to fit the entire row. Massively useful when all grid items should have the same width.")]), _vm._v(" "), _c('Grid', {
    attrs: {
      "liquid": ""
    }
  }, _vm._l(([].concat( Array(7) )), function(i) {
    return _c('Grid-item', {
      key: i
    }, [_c('div', {
      staticClass: "demo"
    }, [_vm._v("auto")])])
  })), _vm._v(" "), _c('h2', [_vm._v("Stretch modifier")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("This modifier will equal height of grid items.")]), _vm._v(" "), _c('Grid', {
    attrs: {
      "liquid": "",
      "stretch": ""
    }
  }, [_c('Grid-item', [_c('div', {
    staticClass: "demo"
  }, [_vm._v("1/3")])]), _vm._v(" "), _c('Grid-item', [_c('div', {
    staticClass: "demo"
  }, [_vm._v(_vm._s(_vm.slot))])]), _vm._v(" "), _c('Grid-item', [_c('div', {
    staticClass: "demo"
  }, [_vm._v("1/3")])])], 1), _vm._v(" "), _c('h2', [_vm._v("Reverse modifier")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("This modifier will reverse its grid items.")]), _vm._v(" "), _c('Grid', {
    attrs: {
      "reverse": "",
      "liquid": ""
    }
  }, [_c('Grid-item', [_c('div', {
    staticClass: "demo"
  }, [_vm._v("First")])]), _vm._v(" "), _c('Grid-item', [_c('div', {
    staticClass: "demo"
  }, [_vm._v("Second")])]), _vm._v(" "), _c('Grid-item', [_c('div', {
    staticClass: "demo"
  }, [_vm._v("Last")])])], 1), _vm._v(" "), _c('h2', [_vm._v("Auto modifier")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("This modifier will size the element according to its size property (which can itself be auto, which sizes the element based on its contents).")]), _vm._v(" "), _c('Grid', {
    attrs: {
      "auto": ""
    }
  }, [_c('Grid-item', [_c('img', {
    attrs: {
      "src": "http://fakeimg.pl/320x240/"
    }
  })]), _vm._v(" "), _c('Grid-item', [_c('img', {
    attrs: {
      "src": "http://fakeimg.pl/640x480/"
    }
  })]), _vm._v(" "), _c('Grid-item', [_c('img', {
    attrs: {
      "src": "http://fakeimg.pl/800x600/"
    }
  })]), _vm._v(" "), _c('Grid-item', [_c('img', {
    attrs: {
      "src": "http://fakeimg.pl/1024x768/"
    }
  })]), _vm._v(" "), _c('Grid-item', [_c('img', {
    attrs: {
      "src": "http://fakeimg.pl/1280x960/"
    }
  })])], 1), _vm._v(" "), _c('h2', [_vm._v("Wrapped modifier")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', [_vm._v("Wrap items with a padding instead of using the padding as a column gutter.")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('Grid', {
    attrs: {
      "wrapped": "",
      "liquid": ""
    }
  }, _vm._l(([1, 2, 3]), function(i) {
    return _c('Grid-item', {
      key: i
    }, [_c('div', {
      staticClass: "demo"
    }, [_vm._v("1/3")])])
  })), _vm._v(" "), _vm._l((_vm.size_values), function(size) {
    return _c('div', {
      key: size
    }, [_c('h3', [_vm._v(_vm._s(size))]), _vm._v(" "), _c('Grid', {
      attrs: {
        "wrapped": "",
        "liquid": "",
        "size": size
      }
    }, _vm._l(([1, 2, 3]), function(i) {
      return _c('Grid-item', {
        key: i
      }, [_c('div', {
        staticClass: "demo"
      }, [_vm._v("1/3")])])
    }))], 1)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The Grid component consists of two components: the "), _c('samp', [_vm._v("<Grid>")]), _vm._v(" wrapper and the "), _c('samp', [_vm._v("<Grid-item>")]), _vm._v("\n  component, which is supposed to live inside the wrapper.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("prop: "), _c('b', [_vm._v("width")]), _c('br'), _vm._v("values: any combination of "), _c('b', [_vm._v("[1, 2, 3, 4, 5, 6]")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("prop: "), _c('b', [_vm._v("size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("prop: "), _c('b', [_vm._v("align")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("prop: "), _c('b', [_vm._v("liquid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("prop: "), _c('b', [_vm._v("stretch")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("prop: "), _c('b', [_vm._v("reverse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("prop: "), _c('b', [_vm._v("auto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("prop: "), _c('b', [_vm._v("wrapped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', [_vm._v("(default)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29054a5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/GridShowcase.vue
// module id = 56
// module chunks = 0